import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["id", "ignoreMetaId", "limit"],
  _excluded2 = ["data"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Slider from "@/components/Slider";
import { useTvShowEpisodesQuery } from "@/hooks";
import Card from "@/components/Card/index";
import { SLIDER_MAX_NUM } from "@/lib/constants";
import { jsx as _jsx } from "react/jsx-runtime";
export default function TvShowEpisodesSlider(_ref) {
  var _items$data;
  let {
      id,
      ignoreMetaId,
      limit = SLIDER_MAX_NUM
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const _useTvShowEpisodesQue = useTvShowEpisodesQuery({
      variables: {
        offset: 0,
        limit,
        id,
        filter: {
          not: {
            meta_id: ignoreMetaId
          }
        }
      }
    }),
    {
      data
    } = _useTvShowEpisodesQue,
    result = _objectWithoutProperties(_useTvShowEpisodesQue, _excluded2);
  const items = data === null || data === void 0 ? void 0 : data.children;
  if ((items === null || items === void 0 || (_items$data = items.data) === null || _items$data === void 0 ? void 0 : _items$data.length) === 0) return null;
  return /*#__PURE__*/_jsx(Slider, _objectSpread(_objectSpread(_objectSpread({}, props), result), {}, {
    itemComponent: Card,
    items: items
  }));
}